module.exports = __webpack_public_path__ + "static/index.spec.js.02d945cedd6bfc5f7bba590b9bd0271f.snap";